import { render, staticRenderFns } from "./ProjectModel.vue?vue&type=template&id=1fa55860&scoped=true&"
import script from "./ProjectModel.vue?vue&type=script&lang=js&"
export * from "./ProjectModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa55860",
  null
  
)

export default component.exports